import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export enum BoardMeetingContentType {
  INFORMATION = "information",
  DECISION = "decision",
}

export enum BoardMeetingDecision {
  RESOLVED = "resolved",
  TABLED = "tabled",
  DISMISSED = "dismissed",
}

export enum BoardMeetingContentState {
  OPEN = "open",
  CLOSED = "closed",
}

export const boardMeetingContentSchema = surrealRecordSchema.extend({
  index: z.number(),
  type: z.nativeEnum(BoardMeetingContentType),
  statement: z.string(),
  conclusion: z.string().optional(),
  decision: z.nativeEnum(BoardMeetingDecision).optional(),
  state: z.nativeEnum(BoardMeetingContentState),
  // Snapshot of conclusion and decision taken when the meeting ended, before cleaning
  endedConclusion: z.string().optional(),
  endedDecision: z.nativeEnum(BoardMeetingDecision).optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BoardMeetingContent = z.infer<typeof boardMeetingContentSchema>;
